import { SvgIcon, SvgIconProps } from '@mui/material';

export function UserGroupIllustration(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 500 500'
    >
      <g filter='url(#filter0_i_511_55)'>
        <rect
          width='500'
          height='500'
          rx='250'
          fill='#F0F5FF'
        />
        <rect
          x='297.321'
          y='104.278'
          width='12.5805'
          height='46.1284'
          rx='3'
          transform='rotate(2.19916 297.321 104.278)'
          fill='#C5DCFB'
        />
        <rect
          x='367.381'
          y='130.398'
          width='12.5805'
          height='46.1283'
          rx='3'
          transform='rotate(45.1727 367.381 130.398)'
          fill='#C5DCFB'
        />
        <rect
          x='397.863'
          y='199.284'
          width='12.5805'
          height='46.1283'
          rx='3'
          transform='rotate(90.6939 397.863 199.284)'
          fill='#C5DCFB'
        />
        <g filter='url(#filter1_d_511_55)'>
          <path
            d='M341.683 344.773C341.683 353.456 340.002 363.571 336.947 371.16H203.192C200.137 363.571 198.456 355.281 198.456 346.597C198.456 310.283 228.561 274.459 272.35 274.459C311.363 274.459 341.683 307.546 341.683 344.773Z'
            fill='#D6E4FF'
          />
          <path
            d='M278.736 341.431C278.736 351.913 276.704 361.92 273.013 371.08H125.723C122.032 361.92 120 351.913 120 341.431C120 297.597 155.534 262.063 199.368 262.063C243.202 262.063 278.736 297.597 278.736 341.431Z'
            fill='#D6E4FF'
          />
        </g>
        <path
          d='M341.683 344.862C341.683 354.159 339.885 363.036 336.618 371.161H271.438H206.258C202.991 363.036 201.193 354.159 201.193 344.862C201.193 305.98 232.642 274.46 271.438 274.46C310.233 274.46 341.683 305.98 341.683 344.862Z'
          fill='#3E8FFA'
        />
        <path
          d='M278.736 341.431C278.736 351.913 276.704 361.92 273.013 371.08H199.368H125.723C122.032 361.92 120 351.913 120 341.431C120 297.597 155.534 262.063 199.368 262.063C243.202 262.063 278.736 297.597 278.736 341.431Z'
          fill='#1F477D'
        />
        <g filter='url(#filter2_d_511_55)'>
          <circle
            cx='270.982'
            cy='226.566'
            r='40.5963'
            fill='#3E8FFA'
          />
        </g>
        <g filter='url(#filter3_d_511_55)'>
          <circle
            cx='198.959'
            cy='209.656'
            r='46.117'
            fill='#1F477D'
          />
        </g>
      </g>
      <defs>
        <filter
          id='filter0_i_511_55'
          x='0'
          y='0'
          width='509'
          height='520'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='9'
            dy='25'
          />
          <feGaussianBlur stdDeviation='10' />
          <feComposite
            in2='hardAlpha'
            operator='arithmetic'
            k2='-1'
            k3='1'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.7275 0 0 0 0 0.810305 0 0 0 0 0.97 0 0 0 0.6 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect1_innerShadow_511_55'
          />
        </filter>
        <filter
          id='filter1_d_511_55'
          x='118'
          y='262.063'
          width='235.683'
          height='126.097'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='5'
            dy='10'
          />
          <feGaussianBlur stdDeviation='3.5' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.176471 0 0 0 0 0.435294 0 0 0 0 0.843137 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_511_55'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_511_55'
            result='shape'
          />
        </filter>
        <filter
          id='filter2_d_511_55'
          x='222.385'
          y='181.969'
          width='105.193'
          height='105.193'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='4'
            dy='8'
          />
          <feGaussianBlur stdDeviation='6' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_511_55'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_511_55'
            result='shape'
          />
        </filter>
        <filter
          id='filter3_d_511_55'
          x='144.842'
          y='159.539'
          width='116.234'
          height='116.234'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset
            dx='4'
            dy='8'
          />
          <feGaussianBlur stdDeviation='6' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_511_55'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_511_55'
            result='shape'
          />
        </filter>
      </defs>
    </SvgIcon>
  );
}
